import { render, staticRenderFns } from "./PricingCalculator.vue?vue&type=template&id=e453f2fc"
import script from "./PricingCalculator.vue?vue&type=script&lang=js"
export * from "./PricingCalculator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports